import { BaseModal, ModalOptions, ModalResultType } from "../../../../../core/modal/index";
import { Template } from "../../../../../core/template/index";
import { ShelveItemView } from "../../receive/partials/shelve_item/index";

export default class ShelveModal extends BaseModal
{
    public template = Template.lazy('/app/views/package_tracking/modals/shelve/index.html');
    
    shelfInput: HTMLInputElement;
    scannedItem: ShelveItemView;

    constructor(scannedItem: ShelveItemView)
    {
        super(scannedItem.data);
        this.scannedItem = scannedItem;

    }

    public get defaults(): ModalOptions
    {
        return {
            title: this.pgettext('Title', 'Shelve package')
        }
    }

    protected afterVisible()
    {
        this.shelfInput.focus();
    }

    public onSubmit(event: Event)
    {
        event.preventDefault();
        this.scannedItem.onShelved(this.data.shelf);
    }
}